export interface KpiCard {
  icon: string;
  label: string;
  value: number;
  color: string;
  iconBg: string;
}

export interface TaskItem {
  title: string;
  deadline: string;
  priority: string;
  client: string;
  status: string;
  assignedTo?: string;
  manager?: string;
  order?: string;
}

export interface NextActionItem {
  dateTime: string;
  client: string;
  action: string;
  manager: string;
}

export interface ShipmentItem {
  client: string;
  document: string;
  date: string;
  status: string;
  statusColor: string;
}

export interface RequestItem {
  id: string;
  client: string;
  product: string;
  qty: string;
  status: string;
  statusColor: string;
}

export interface CommunicationItem {
  type: string;
  typeIcon: string;
  typeColor: string;
  content: string;
  time: string;
}

export interface CommunicationGroup {
  key: string;
  label: string;
  icon: string;
  total: number;
  unanswered: number;
}

export interface NoContactClient {
  name: string;
  lastContact: string;
  nextContact: string;
  manager: string;
}

export interface UnpaidInvoice {
  client: string;
  document: string;
  amount: number;
  days: number;
}

export interface RecentPayment {
  client: string;
  document: string;
  amount: number;
  date: string;
  org: string;
}

export interface CalendarEvent {
  time: string;
  title: string;
}

export interface ManagerTip {
  icon: string;
  text: string;
}

export interface ProcessStep {
  label: string;
  icon: string;
  active?: boolean;
}

export interface UnansweredOffer {
  client: string;
  document: string;
  date: string;
  days: number;
}

export interface DormantClient {
  name: string;
  lastPurchase: string;
  daysSincePurchase: number;
  manager: string;
  productGroup: string;
}

export interface DealWithoutStep {
  client: string;
  dealId: string;
  stage: string;
  lastActivity: string;
  daysWithoutAction: number;
}

export interface PriorityClient {
  name: string;
  reason: string;
  task: string;
  importance: string;
}

export interface AiTip {
  icon: string;
  priority: string;
  priorityColor: string;
  text: string;
  action: string;
}

export interface MessageTemplate {
  title: string;
  client: string;
  preview: string;
  type: string;
}

export interface UpsellRecommendation {
  client: string;
  currentProduct: string;
  recommendedProduct: string;
  reason: string;
  potentialAmount: number;
}

export interface TaskRule {
  title: string;
  icon: string;
  description: string;
  examples: string[];
}

export interface ManagerKpiItem {
  label: string;
  icon: string;
  plan: number;
  fact: number;
  unit: string;
  color: string;
  iconBg: string;
}

export interface ConversionItem {
  label: string;
  from: string;
  to: string;
  rate: number;
  trend: string;
}

export interface TaskTrigger {
  trigger: string;
  condition: string;
  task: string;
  priority: string;
  icon: string;
}

export interface ActiveDeal {
  client: string;
  dealId: string;
  product: string;
  amount: number;
  stage: string;
  daysActive: number;
  nextAction: string;
}

export interface OrderInProgress {
  id: string;
  client: string;
  product: string;
  qty: string;
  amount: number;
  status: string;
  statusColor: string;
  paymentStatus: string;
  paymentStatusColor: string;
  date: string;
}

export interface ProcurementRequest {
  id: string;
  client: string;
  product: string;
  qty: string;
  status: string;
  statusColor: string;
  date: string;
}

export interface ReturnRequest {
  id: string;
  client: string;
  saleDoc: string;
  reason: string;
  amount: number;
  status: string;
  statusColor: string;
  date: string;
}

export interface CustomerReturnItem {
  id: string;
  client: string;
  returnDoc: string;
  product: string;
  qty: string;
  amount: number;
  status: string;
  statusColor: string;
  date: string;
}

export interface KanbanCard {
  id: string;
  client: string;
  product: string;
  amount: number;
  stage: string;
  daysActive: number;
  manager: string;
  nextAction: string;
}

export interface KanbanStage {
  key: string;
  label: string;
  color: string;
  icon: string;
  cards: KanbanCard[];
}

export interface ClientKanbanCard {
  name: string;
  segment: string;
  manager: string;
  lastPurchase: string;
  daysSincePurchase: number;
  totalRevenue: number;
  ordersCount: number;
  productGroup?: string;
  lastSaleDoc?: string;
  phone: string;
  status: string;
}

export interface ClientKanbanStage {
  key: string;
  label: string;
  color: string;
  icon: string;
  cards: ClientKanbanCard[];
}

export const kpiCards: KpiCard[] = [
  { icon: "ri-shake-hands-line", label: "Активные сделки", value: 18, color: "text-[#2D6A4F]", iconBg: "bg-[#D4EDDA]" },
  { icon: "ri-file-close-line", label: "КП без ответа", value: 4, color: "text-[#DC2626]", iconBg: "bg-[#FEE2E2]" },
  { icon: "ri-file-list-2-line", label: "Заказы в работе", value: 11, color: "text-[#D97706]", iconBg: "bg-[#FEF3C7]" },
  { icon: "ri-tools-line", label: "Сборка на складе", value: 3, color: "text-[#D97706]", iconBg: "bg-[#FEF3C7]" },
  { icon: "ri-truck-line", label: "Доставки сегодня", value: 3, color: "text-[#2D6A4F]", iconBg: "bg-[#D4EDDA]" },
  { icon: "ri-wallet-3-line", label: "Клиенты с долгом", value: 9, color: "text-[#B45309]", iconBg: "bg-[#FDE68A]" },
];

export const todayTasks = 14;
export const overdueTasks = 2;
export const todayPayment = 875240;

export const myTasks: TaskItem[] = [
  { title: "Позвонить по КП", deadline: "15.05.2026 10:00", priority: "Высокий", client: "ТОО «Восток Трейд»", status: "В работе" },
  { title: "Согласовать условия", deadline: "15.05.2026 11:30", priority: "Средний", client: "ООО «СтройКомплект»", status: "В работе" },
  { title: "Подготовить КП", deadline: "15.05.2026 11:00", priority: "Высокий", client: "ИП Султанов Е.Б.", status: "В работе" },
  { title: "Проверить отгрузку", deadline: "15.05.2026 09:30", priority: "Высокий", client: "ТОО «Металл Пром»", status: "Просрочена" },
  { title: "Обновить статус сделки", deadline: "15.05.2026 13:00", priority: "Низкий", client: "ТОО «Пром Сталь»", status: "В работе" },
  { title: "Подготовить отчёт за неделю", deadline: "15.05.2026 18:00", priority: "Низкий", client: "—", status: "Новая" },
  { title: "Встреча с РОП по плану", deadline: "15.05.2026 11:00", priority: "Средний", client: "—", status: "Новая" },
  { title: "Согласовать скидку по сделке СД-00091", deadline: "15.05.2026 14:30", priority: "Высокий", client: "ТОО «Восток Трейд»", status: "Новая" },
];

export const assignedTasks: TaskItem[] = [
  { title: "Отправить счет клиенту", deadline: "15.05.2026 12:00", priority: "Средний", client: "ТОО «Альфа Сталь»", status: "Новая", assignedTo: "Оператор Петров А.С.", manager: "Иванов И.И.", order: "ЗК-00125" },
  { title: "Уточнить потребность по заявке", deadline: "15.05.2026 17:00", priority: "Низкий", client: "ООО «ТехноПласт»", status: "В работе", assignedTo: "Оператор Сидоров К.М.", manager: "Иванов И.И.", order: "ЗК-00129" },
  { title: "Созвониться с бухгалтерией клиента", deadline: "15.05.2026 14:00", priority: "Средний", client: "ООО «КазСнаб»", status: "Новая", assignedTo: "Оператор Петров А.С.", manager: "Иванов И.И.", order: "ЗК-00131" },
  { title: "Отправить ТЗ на склад", deadline: "15.05.2026 15:30", priority: "Высокий", client: "ИП Ким А.А.", status: "В работе", assignedTo: "Оператор Сидоров К.М.", manager: "Смирнова А.В.", order: "ЗК-00133" },
  { title: "Согласовать доставку с логистом", deadline: "15.05.2026 16:00", priority: "Средний", client: "ТОО «Юг-Снаб»", status: "Просрочена", assignedTo: "Оператор Петров А.С.", manager: "Смирнова А.В.", order: "ЗК-00134" },
  { title: "Внести данные по новому клиенту в CRM", deadline: "16.05.2026 10:00", priority: "Низкий", client: "ООО «ТеплоДом»", status: "Новая", assignedTo: "Оператор Сидоров К.М.", manager: "Иванов И.И.", order: "ЗК-00135" },
];

export const nextActions: NextActionItem[] = [
  { dateTime: "15.05 12:00", client: "ТОО «Восток Трейд»", action: "Телефонный звонок", manager: "Иванов И.И." },
  { dateTime: "15.05 13:30", client: "ООО «СтройКомплект»", action: "Встреча", manager: "Иванов И.И." },
  { dateTime: "15.05 15:00", client: "ИП Султанов Е.Б.", action: "Отправить КП", manager: "Иванов И.И." },
  { dateTime: "16.05 09:30", client: "ТОО «Альфа Сталь»", action: "Телефонный звонок", manager: "Иванов И.И." },
  { dateTime: "16.05 11:30", client: "ООО «ТехноПласт»", action: "Уточнить потребности", manager: "Иванов И.И." },
];

export const warehouseAssembly: ShipmentItem[] = [
  { client: "ООО «СтройКомплект»", document: "РТУ-000247", date: "16.05.2026", status: "Ожидает сборки", statusColor: "bg-[#FEF3C7] text-[#D97706]" },
  { client: "ТОО «Альфа Сталь»", document: "РТУ-000249", date: "17.05.2026", status: "Заказана", statusColor: "bg-[#FEE2E2] text-[#DC2626]" },
  { client: "ООО «ТехноПласт»", document: "РТУ-000255", date: "18.05.2026", status: "Ожидает сборки", statusColor: "bg-[#FEF3C7] text-[#D97706]" },
  { client: "ТОО «Пром Сталь»", document: "РТУ-000261", date: "19.05.2026", status: "Заказана", statusColor: "bg-[#FEE2E2] text-[#DC2626]" },
];

export const deliveriesToday: ShipmentItem[] = [
  { client: "ТОО «Восток Трейд»", document: "РТУ-000246", date: "15.05.2026", status: "Готов к отгрузке", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]" },
  { client: "ИП Султанов Е.Б.", document: "РТУ-000252", date: "15.05.2026", status: "Отгружена", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]" },
  { client: "ТОО «Металл Пром»", document: "РТУ-000258", date: "15.05.2026", status: "Готов к отгрузке", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]" },
  { client: "ООО «КазСнаб»", document: "РТУ-000264", date: "15.05.2026", status: "В пути", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]" },
];

export const shipments: ShipmentItem[] = [
  { client: "ТОО «Восток Трейд»", document: "РТУ-000246", date: "15.05.2026", status: "Готов к отгрузке", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]" },
  { client: "ООО «СтройКомплект»", document: "РТУ-000247", date: "16.05.2026", status: "Ожидает сборки", statusColor: "bg-[#FEF3C7] text-[#D97706]" },
  { client: "ТОО «Альфа Сталь»", document: "РТУ-000249", date: "17.05.2026", status: "Заказана", statusColor: "bg-[#FEE2E2] text-[#DC2626]" },
  { client: "ИП Султанов Е.Б.", document: "РТУ-000252", date: "15.05.2026", status: "Отгружена", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]" },
  { client: "ООО «ТехноПласт»", document: "РТУ-000255", date: "18.05.2026", status: "Ожидает сборки", statusColor: "bg-[#FEF3C7] text-[#D97706]" },
  { client: "ТОО «Металл Пром»", document: "РТУ-000258", date: "19.05.2026", status: "Готов к отгрузке", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]" },
];

export const requests: RequestItem[] = [
  { id: "ZS-00125", client: "ТОО «Восток Трейд»", product: "Смазка 0600", qty: "1 200 м", status: "Новый", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]" },
  { id: "ZS-00126", client: "ООО «СтройКомплект»", product: "Метиз, гриверса", qty: "5 000 шт", status: "В работе", statusColor: "bg-[#FEF3C7] text-[#D97706]" },
  { id: "ZS-00127", client: "ИП Султанов Е.Б.", product: "Профиль 50 мм", qty: "800 м", status: "Заказ поставщику", statusColor: "bg-[#FDE68A] text-[#B45309]" },
  { id: "ZS-00128", client: "ТОО «Альфа Сталь»", product: "Ниппель 1/2\"", qty: "300 шт", status: "Поступление", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]" },
  { id: "ZS-00129", client: "ООО «ТехноПласт»", product: "Саморезы 0700", qty: "600 шт", status: "Поступление", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]" },
];

export const communicationGroups: CommunicationGroup[] = [
  { key: "chats", label: "Чаты", icon: "ri-chat-3-line", total: 12, unanswered: 3 },
  { key: "calls", label: "Звонки", icon: "ri-phone-line", total: 8, unanswered: 2 },
  { key: "email", label: "Почта", icon: "ri-mail-line", total: 15, unanswered: 5 },
];

export const communications: CommunicationItem[] = [
  { type: "Телефон", typeIcon: "ri-phone-line", typeColor: "bg-[#D4EDDA] text-[#2D6A4F]", content: "+7 (727) 355-31-48", time: "10:32" },
  { type: "WhatsApp", typeIcon: "ri-whatsapp-line", typeColor: "bg-[#D4EDDA] text-[#2D6A4F]", content: "ТОО «Восток Трейд»", time: "10:16" },
  { type: "Email", typeIcon: "ri-mail-line", typeColor: "bg-[#FEF3C7] text-[#D97706]", content: "info@stroykomplekt.kz", time: "09:47" },
  { type: "Телефон", typeIcon: "ri-phone-line", typeColor: "bg-[#D4EDDA] text-[#2D6A4F]", content: "+7 (727) 355-31-48", time: "09:15" },
];

export const noContactClients: NoContactClient[] = [
  { name: "ТОО «Пром Сталь»", lastContact: "12.03.2026", nextContact: "18.03.2026", manager: "Иванов И.И." },
  { name: "ООО «Металл»", lastContact: "18.02.2026", nextContact: "—", manager: "Иванов И.И." },
  { name: "ИП Ким А.А.", lastContact: "05.02.2026", nextContact: "27.03.2026", manager: "Иванов И.И." },
  { name: "ТОО «Юг-Снаб»", lastContact: "15.01.2026", nextContact: "—", manager: "Иванов И.И." },
];

export const unpaidInvoices: UnpaidInvoice[] = [
  { client: "ТОО «Восток Трейд»", document: "Сч-000345", amount: 1245600, days: 12 },
  { client: "ООО «СтройКомплект»", document: "Сч-000411", amount: 586200, days: 8 },
  { client: "ИП Султанов Е.Б.", document: "Сч-000381", amount: 312400, days: 6 },
  { client: "ТОО «Альфа Сталь»", document: "Сч-000352", amount: 376200, days: 2 },
  { client: "ООО «ТехноПласт»", document: "Сч-000326", amount: 189700, days: 1 },
  { client: "ТОО «Металл Пром»", document: "Сч-000418", amount: 834500, days: 15 },
  { client: "ООО «КазСнаб»", document: "Сч-000397", amount: 245800, days: 4 },
  { client: "ТОО «Пром Сталь»", document: "Сч-000405", amount: 518300, days: 9 },
  { client: "ИП Ким А.А.", document: "Сч-000387", amount: 168900, days: 7 },
];

export const recentPayments: RecentPayment[] = [
  { client: "ТОО «Восток Трейд»", document: "ПП-000156 / СЧ-000298", amount: 450000, date: "15.05.2026 10:45", org: "ТОО «Альфа-Сталь»" },
  { client: "ООО «СтройКомплект»", document: "ПП-000155 / СЧ-000301", amount: 186200, date: "15.05.2026 09:32", org: "ТОО «Альфа-Сталь»" },
  { client: "ИП Султанов Е.Б.", document: "ПП-000154 / СЧ-000287", amount: 238000, date: "14.05.2026 16:20", org: "ТОО «Альфа-Сталь»" },
  { client: "ТОО «Альфа Сталь»", document: "ПП-000153 / СЧ-000276", amount: 325000, date: "14.05.2026 11:18", org: "ТОО «Альфа-Сталь»" },
  { client: "ООО «ТехноПласт»", document: "ПП-000152 / СЧ-000274", amount: 187000, date: "13.05.2026 15:05", org: "ТОО «Альфа-Сталь»" },
];

export const calendarEvents: CalendarEvent[] = [
  { time: "10:30", title: "Позвонить ТОО «Восток Трейд»" },
  { time: "11:00", title: "Согласование КП с ООО «СтройКомплект»" },
  { time: "12:00", title: "Проведение встречи с ИП Султанов Е.Б." },
  { time: "14:00", title: "Отправить счет ТОО «Альфа Сталь»" },
  { time: "16:00", title: "Уточнить потребности ООО «ТехноПласт»" },
];

export const managerTips: ManagerTip[] = [
  { icon: "ri-check-line", text: "Видит, кто уже оплатил" },
  { icon: "ri-check-line", text: "Контролирует поступления" },
  { icon: "ri-check-line", text: "Понимает, на какой этап закупка" },
  { icon: "ri-check-line", text: "Не теряет запросы по дебиторской задолженности" },
];

export const processSteps: ProcessStep[] = [
  { label: "Рабочее место менеджера", icon: "ri-user-settings-line", active: true },
  { label: "CRM 360 клиента", icon: "ri-user-search-line" },
  { label: "Сделка", icon: "ri-shake-hands-line" },
  { label: "Заказ / Счет", icon: "ri-file-list-2-line" },
  { label: "Отгрузка", icon: "ri-truck-line" },
  { label: "Запрос по остатку", icon: "ri-questionnaire-line" },
  { label: "Закупка / Поступление", icon: "ri-shopping-basket-line" },
];

export const unansweredOffers: UnansweredOffer[] = [
  { client: "ТОО «Металл Пром»", document: "КП-000184", date: "08.05.2026", days: 7 },
  { client: "ООО «КазСнаб»", document: "КП-000179", date: "05.05.2026", days: 10 },
  { client: "ИП Султанов Е.Б.", document: "КП-000177", date: "02.05.2026", days: 13 },
  { client: "ТОО «Юг-Снаб»", document: "КП-000172", date: "28.04.2026", days: 17 },
];

export const dormantClients: DormantClient[] = [
  { name: "ТОО «Пром Сталь»", lastPurchase: "12.01.2026", daysSincePurchase: 185, manager: "Иванов И.И.", productGroup: "Метизы" },
  { name: "ООО «Металл»", lastPurchase: "18.02.2026", daysSincePurchase: 148, manager: "Иванов И.И.", productGroup: "Крепёж" },
  { name: "ИП Ким А.А.", lastPurchase: "05.12.2025", daysSincePurchase: 223, manager: "Иванов И.И.", productGroup: "Профиль" },
  { name: "ТОО «Юг-Снаб»", lastPurchase: "15.03.2026", daysSincePurchase: 123, manager: "Иванов И.И.", productGroup: "Смазка" },
  { name: "ООО «СтройДом»", lastPurchase: "20.11.2025", daysSincePurchase: 238, manager: "Иванов И.И.", productGroup: "Фурнитура" },
];

export const dealsWithoutStep: DealWithoutStep[] = [
  { client: "ТОО «Металл Пром»", dealId: "СД-00089", stage: "Подготовка КП", lastActivity: "05.05.2026", daysWithoutAction: 10 },
  { client: "ООО «КазСнаб»", dealId: "СД-00092", stage: "Согласование условий", lastActivity: "01.05.2026", daysWithoutAction: 14 },
  { client: "ТОО «Восток Трейд»", dealId: "СД-00085", stage: "Переговоры", lastActivity: "07.05.2026", daysWithoutAction: 8 },
  { client: "ИП Ким А.А.", dealId: "СД-00078", stage: "Ожидание решения", lastActivity: "22.04.2026", daysWithoutAction: 23 },
];

export const priorityClients: PriorityClient[] = [
  { name: "ТОО «Восток Трейд»", reason: "Просроченная оплата 1.2M₽ + новые заказы", task: "Позвонить, согласовать оплату", importance: "Критично" },
  { name: "ООО «СтройКомплект»", reason: "Сделка на 2.5M₽ на финальной стадии", task: "Отправить финальное КП", importance: "Высокий" },
  { name: "ИП Султанов Е.Б.", reason: "КП без ответа 13 дней, рискуем потерять", task: "Уточнить статус решения", importance: "Средний" },
  { name: "ТОО «Альфа Сталь»", reason: "Потенциал допродажи +300K₽", task: "Предложить расширенный ассортимент", importance: "Средний" },
  { name: "ООО «ТехноПласт»", reason: "Новый клиент, первый заказ на подходе", task: "Провести онбординг-звонок", importance: "Высокий" },
];

export const aiTips: AiTip[] = [
  {
    icon: "ri-alert-line",
    priority: "Срочно",
    priorityColor: "bg-[#FEE2E2] text-[#DC2626]",
    text: "У ИП Султанов Е.Б. КП без ответа уже 13 дней. Рекомендую позвонить сегодня до 12:00 — по статистике после 14 дней вероятность закрытия падает на 40%.",
    action: "Позвонить сейчас",
  },
  {
    icon: "ri-lightbulb-line",
    priority: "Важно",
    priorityColor: "bg-[#FEF3C7] text-[#D97706]",
    text: "У ООО «СтройКомплект» сделка на 2.5M₽. Последняя активность была 3 дня назад. Предложи встречу на завтра — сделки с паузой >5 дней теряют импульс.",
    action: "Назначить встречу",
  },
  {
    icon: "ri-money-dollar-circle-line",
    priority: "Возможность",
    priorityColor: "bg-[#D4EDDA] text-[#2D6A4F]",
    text: "ТОО «Восток Трейд» регулярно закупает смазку 0600. У них нет заказа на фурнитуру — потенциал допродажи ~350K₽. Включи в следующее КП.",
    action: "Подготовить КП",
  },
];

export const messageTemplates: MessageTemplate[] = [
  {
    title: "Напоминание о КП",
    client: "ТОО «Металл Пром»",
    preview: "Здравствуйте, [Имя]! Направляли Вам КП №000184 от 08.05.2026. Подскажите, пожалуйста, требуется ли дополнительная информация для принятия решения?",
    type: "Email",
  },
  {
    title: "Возврат inactive-клиента",
    client: "ИП Ким А.А.",
    preview: "Здравствуйте, [Имя]! Давно не общались. У нас появилась новая линейка профиля с улучшенными характеристиками. Готовы сделать персональное предложение — когда удобно обсудить?",
    type: "WhatsApp",
  },
  {
    title: "Уведомление о задолженности",
    client: "ТОО «Восток Трейд»",
    preview: "Здравствуйте, [Имя]! Напоминаем о задолженности по счёту СЧ-000345 на сумму 1 245 600 ₽. Просрочка составляет 12 дней. Просим оплатить в ближайшее время.",
    type: "Email",
  },
];

export const upsellRecommendations: UpsellRecommendation[] = [
  {
    client: "ТОО «Текстиль Пром»",
    currentProduct: "Ткань Oxford 600D",
    recommendedProduct: "Ткань Cordura 1000D",
    reason: "Клиенты, берущие Oxford 600D, в 74% случаев докупают Cordura для усиленных изделий",
    potentialAmount: 420000,
  },
  {
    client: "ООО «Швейный Дом»",
    currentProduct: "Ткань Oxford 420D PU",
    recommendedProduct: "Ткань Taffeta 190T с пропиткой",
    reason: "Комплект Oxford + Taffeta increases средний чек на 35% — подкладочная ткань всегда нужна",
    potentialAmount: 310000,
  },
  {
    client: "ИП Ахметова Г.Ж.",
    currentProduct: "Ткань Грета (смесовая)",
    recommendedProduct: "Ткань Рип-стоп камуфляж",
    reason: "Сезонный спрос на камуфляж — упущенная выручка при отсутствии предложения",
    potentialAmount: 580000,
  },
  {
    client: "ТОО «СпецТкани»",
    currentProduct: "Брезент огнеупорный",
    recommendedProduct: "Ткань ПВХ 650 г/м²",
    reason: "Сопутствующий продукт — 68% заказчиков брезента берут ПВХ-ткань для тентов",
    potentialAmount: 265000,
  },
  {
    client: "ООО «ТексПрофи»",
    currentProduct: "Нить армированная 45ЛЛ",
    recommendedProduct: "Ткань Оксфорд 210D PU",
    reason: "Мелкие закупки нитей → потенциал роста до полноценных заказов ткани",
    potentialAmount: 195000,
  },
];

export const taskRules: TaskRule[] = [
  {
    title: "Правило 1: Задача = конкретное действие",
    icon: "ri-checkbox-circle-line",
    description: "Формулируй задачу как действие, а не цель. Менеджер должен сразу понимать, что именно нужно сделать.",
    examples: ["Позвонить клиенту", "Отправить КП", "Согласовать скидку с РОП"],
  },
  {
    title: "Правило 2: Чёткий срок и время",
    icon: "ri-timer-line",
    description: "Каждая задача должна иметь дату и время. Никаких «на неделе» или «скоро».",
    examples: ["15.05.2026 до 12:00", "Сегодня до 18:00"],
  },
  {
    title: "Правило 3: Приоритет по матрице",
    icon: "ri-flag-line",
    description: "Высокий приоритет — если влияет на деньги или дедлайн сегодня. Средний — до 3 дней. Низкий — до недели.",
    examples: ["Высокий: просроченная оплата", "Средний: подготовка КП", "Низкий: обновление CRM"],
  },
  {
    title: "Правило 4: Одна задача — один клиент",
    icon: "ri-user-line",
    description: "Не группируй несколько клиентов в одну задачу. Каждая задача привязана к одному клиенту для прозрачности.",
    examples: ["Позвонить ТОО «Восток Трейд»", "Отправить счёт ИП Султанову"],
  },
  {
    title: "Правило 5: Задача создаётся сразу после контакта",
    icon: "ri-add-circle-line",
    description: "Следующее действие фиксируется немедленно после созвона/встречи. Не откладывай на конец дня.",
    examples: ["После звонка → сразу создать «Отправить КП»", "После встречи → «Согласовать ТЗ»"],
  },
];

export const managerKpis: ManagerKpiItem[] = [
  { label: "Новые клиенты", icon: "ri-user-add-line", plan: 5, fact: 3, unit: "клиентов", color: "text-[#2D6A4F]", iconBg: "bg-[#D4EDDA]" },
  { label: "Звонки / контакты", icon: "ri-phone-line", plan: 40, fact: 34, unit: "звонков", color: "text-[#D97706]", iconBg: "bg-[#FEF3C7]" },
  { label: "Созданные сделки", icon: "ri-shake-hands-line", plan: 8, fact: 6, unit: "сделок", color: "text-[#2D6A4F]", iconBg: "bg-[#D4EDDA]" },
  { label: "Отправленные КП", icon: "ri-file-text-line", plan: 10, fact: 8, unit: "КП", color: "text-[#D97706]", iconBg: "bg-[#FEF3C7]" },
  { label: "Выставленные счета", icon: "ri-bill-line", plan: 7, fact: 5, unit: "счетов", color: "text-[#2D6A4F]", iconBg: "bg-[#D4EDDA]" },
  { label: "Полученные оплаты", icon: "ri-check-double-line", plan: 3_500_000, fact: 2_875_240, unit: "₽", color: "text-[#2D6A4F]", iconBg: "bg-[#D4EDDA]" },
  { label: "Работа с базой", icon: "ri-group-line", plan: 25, fact: 22, unit: "клиентов", color: "text-[#D97706]", iconBg: "bg-[#FEF3C7]" },
  { label: "Возврат уснувших", icon: "ri-user-received-line", plan: 3, fact: 1, unit: "клиентов", color: "text-[#DC2626]", iconBg: "bg-[#FEE2E2]" },
  { label: "Клиенты без контакта", icon: "ri-user-unfollow-line", plan: 4, fact: 4, unit: "клиентов", color: "text-[#B45309]", iconBg: "bg-[#FDE68A]" },
  { label: "Просроченные задачи", icon: "ri-time-line", plan: 0, fact: 4, unit: "задач", color: "text-[#DC2626]", iconBg: "bg-[#FEE2E2]" },
  { label: "Сделки без след. шага", icon: "ri-error-warning-line", plan: 0, fact: 4, unit: "сделок", color: "text-[#DC2626]", iconBg: "bg-[#FEE2E2]" },
];

export const conversions: ConversionItem[] = [
  { label: "Конверсия", from: "КП", to: "Счёт", rate: 62.5, trend: "up" },
  { label: "Конверсия", from: "Счёт", to: "Оплата", rate: 71.4, trend: "up" },
];

export const taskTriggers: TaskTrigger[] = [
  { trigger: "КП без ответа 3 дня", condition: "> 3 дней", task: "Позвонить клиенту", priority: "Высокий", icon: "ri-file-close-line" },
  { trigger: "Счёт без оплаты 2 дня", condition: "> 2 дней", task: "Напомнить об оплате", priority: "Высокий", icon: "ri-bill-line" },
  { trigger: "Клиент не покупал 45 дней", condition: "> 45 дней", task: "Вернуть клиента", priority: "Средний", icon: "ri-user-received-line" },
  { trigger: "Сделка без след. шага", condition: "> 3 дней", task: "Определить следующее действие", priority: "Высокий", icon: "ri-error-warning-line" },
  { trigger: "Снижение закупок >30%", condition: "падение >30%", task: "Выяснить причину снижения", priority: "Средний", icon: "ri-arrow-down-line" },
  { trigger: "Просроченная дебиторка", condition: "просрочка >0 дн", task: "Связаться по оплате", priority: "Критично", icon: "ri-wallet-3-line" },
  { trigger: "Оплата поступила", condition: "по факту оплаты", task: "Проверить отгрузку", priority: "Средний", icon: "ri-check-double-line" },
  { trigger: "Отгрузка завершена", condition: "по факту отгрузки", task: "Запросить повторный заказ", priority: "Низкий", icon: "ri-truck-line" },
  { trigger: "Новый клиент без контакта", condition: "> 1 дня", task: "Сделать первое касание", priority: "Высокий", icon: "ri-user-add-line" },
  { trigger: "Сделка зависла на этапе", condition: "> срока этапа", task: "Проверить причину зависания", priority: "Средний", icon: "ri-pause-circle-line" },
];

export const activeDeals: ActiveDeal[] = [
  { client: "ООО «СтройКомплект»", dealId: "СД-00094", product: "Метиз, гриверса", amount: 2500000, stage: "Финальное согласование", daysActive: 18, nextAction: "Отправить финальное КП" },
  { client: "ТОО «Восток Трейд»", dealId: "СД-00091", product: "Смазка 0600", amount: 1800000, stage: "Переговоры", daysActive: 12, nextAction: "Согласовать скидку с РОП" },
  { client: "ИП Султанов Е.Б.", dealId: "СД-00088", product: "Профиль 50 мм", amount: 960000, stage: "КП отправлено", daysActive: 7, nextAction: "Позвонить — уточнить статус" },
  { client: "ТОО «Альфа Сталь»", dealId: "СД-00093", product: "Ниппель 1/2\"", amount: 620000, stage: "Сбор потребностей", daysActive: 5, nextAction: "Подготовить спецификацию" },
  { client: "ООО «ТехноПласт»", dealId: "СД-00095", product: "Саморезы 0700", amount: 340000, stage: "Первичный контакт", daysActive: 3, nextAction: "Выставить счёт" },
  { client: "ТОО «Металл Пром»", dealId: "СД-00090", product: "Фурнитура Z-серии", amount: 1450000, stage: "КП отправлено", daysActive: 9, nextAction: "Позвонить — напомнить о КП" },
  { client: "ООО «КазСнаб»", dealId: "СД-00096", product: "Крепёж оцинкованный", amount: 780000, stage: "Переговоры", daysActive: 6, nextAction: "Согласовать объём поставки" },
  { client: "ТОО «Пром Сталь»", dealId: "СД-00097", product: "Профиль 100 мм", amount: 2100000, stage: "Финальное согласование", daysActive: 21, nextAction: "Закрыть сделку — выставить счёт" },
  { client: "ИП Ким А.А.", dealId: "СД-00098", product: "Саморезы 0500", amount: 295000, stage: "Сбор потребностей", daysActive: 2, nextAction: "Уточнить количество" },
  { client: "ТОО «Юг-Снаб»", dealId: "СД-00099", product: "Смазка 0800", amount: 520000, stage: "КП отправлено", daysActive: 11, nextAction: "Позвонить — срочно" },
  { client: "ООО «СтройДом»", dealId: "СД-00100", product: "Фурнитура A-серии", amount: 870000, stage: "Первичный контакт", daysActive: 4, nextAction: "Подготовить презентацию" },
  { client: "ТОО «ЭлектроМир»", dealId: "СД-00101", product: "Метиз, гровер", amount: 430000, stage: "Переговоры", daysActive: 8, nextAction: "Согласовать цену" },
  { client: "ООО «ГидроСталь»", dealId: "СД-00102", product: "Ниппель 3/4\"", amount: 1150000, stage: "Финальное согласование", daysActive: 15, nextAction: "Отправить договор" },
  { client: "ИП Нурланов А.С.", dealId: "СД-00103", product: "Профиль 75 мм", amount: 380000, stage: "Сбор потребностей", daysActive: 1, nextAction: "Выехать на объект" },
  { client: "ТОО «Азия Строй»", dealId: "СД-00104", product: "Крепёж нерж.", amount: 670000, stage: "КП отправлено", daysActive: 10, nextAction: "Уточнить статус тендера" },
  { client: "ООО «ТеплоДом»", dealId: "СД-00105", product: "Смазка 0600", amount: 198000, stage: "Первичный контакт", daysActive: 3, nextAction: "Отправить образцы" },
  { client: "ТОО «СнабКом»", dealId: "СД-00106", product: "Саморезы 0700", amount: 850000, stage: "Переговоры", daysActive: 7, nextAction: "Подготовить спецпредложение" },
  { client: "ООО «МегаСтрой»", dealId: "СД-00107", product: "Фурнитура Z-серии", amount: 3200000, stage: "Финальное согласование", daysActive: 24, nextAction: "Согласовать финальные правки" },
];

export const ordersInProgress: OrderInProgress[] = [
  { id: "ZS-00125", client: "ТОО «Восток Трейд»", product: "Смазка 0600", qty: "1 200 м", amount: 480000, status: "Новый", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", paymentStatus: "Не оплачен", paymentStatusColor: "bg-[#FEE2E2] text-[#DC2626]", date: "15.05.2026" },
  { id: "ZS-00126", client: "ООО «СтройКомплект»", product: "Метиз, гриверса", qty: "5 000 шт", amount: 750000, status: "В работе", statusColor: "bg-[#FEF3C7] text-[#D97706]", paymentStatus: "Частичная оплата", paymentStatusColor: "bg-[#FDE68A] text-[#B45309]", date: "14.05.2026" },
  { id: "ZS-00127", client: "ИП Султанов Е.Б.", product: "Профиль 50 мм", qty: "800 м", amount: 320000, status: "Заказ поставщику", statusColor: "bg-[#FDE68A] text-[#B45309]", paymentStatus: "Оплачен", paymentStatusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "13.05.2026" },
  { id: "ZS-00128", client: "ТОО «Альфа Сталь»", product: "Ниппель 1/2\"", qty: "300 шт", amount: 180000, status: "Поступление", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", paymentStatus: "Оплачен", paymentStatusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "12.05.2026" },
  { id: "ZS-00129", client: "ООО «ТехноПласт»", product: "Саморезы 0700", qty: "600 шт", amount: 95000, status: "Поступление", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", paymentStatus: "Оплачен", paymentStatusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "11.05.2026" },
  { id: "ZS-00130", client: "ТОО «Металл Пром»", product: "Фурнитура Z-серии", qty: "200 компл", amount: 560000, status: "В работе", statusColor: "bg-[#FEF3C7] text-[#D97706]", paymentStatus: "Не оплачен", paymentStatusColor: "bg-[#FEE2E2] text-[#DC2626]", date: "15.05.2026" },
  { id: "ZS-00131", client: "ООО «КазСнаб»", product: "Крепёж оцинкованный", qty: "3 200 шт", amount: 410000, status: "Новый", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", paymentStatus: "Ожидает счёт", paymentStatusColor: "bg-[#FEF3C7] text-[#D97706]", date: "15.05.2026" },
  { id: "ZS-00132", client: "ТОО «Пром Сталь»", product: "Профиль 100 мм", qty: "1 500 м", amount: 980000, status: "Заказ поставщику", statusColor: "bg-[#FDE68A] text-[#B45309]", paymentStatus: "Частичная оплата", paymentStatusColor: "bg-[#FDE68A] text-[#B45309]", date: "10.05.2026" },
  { id: "ZS-00133", client: "ИП Ким А.А.", product: "Саморезы 0500", qty: "450 шт", amount: 145000, status: "В работе", statusColor: "bg-[#FEF3C7] text-[#D97706]", paymentStatus: "Оплачен", paymentStatusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "09.05.2026" },
  { id: "ZS-00134", client: "ТОО «Юг-Снаб»", product: "Смазка 0800", qty: "800 м", amount: 220000, status: "Поступление", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", paymentStatus: "Оплачен", paymentStatusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "08.05.2026" },
  { id: "ZS-00135", client: "ООО «СтройДом»", product: "Фурнитура A-серии", qty: "150 компл", amount: 375000, status: "Новый", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", paymentStatus: "Не оплачен", paymentStatusColor: "bg-[#FEE2E2] text-[#DC2626]", date: "15.05.2026" },
];

export const procurementRequests: ProcurementRequest[] = [
  { id: "ЗП-00142", client: "ТОО «Восток Трейд»", product: "Смазка 0600", qty: "1 200 м", status: "Отправлен", statusColor: "bg-[#FEF3C7] text-[#D97706]", date: "15.05.2026" },
  { id: "ЗП-00141", client: "ООО «СтройКомплект»", product: "Метиз, гриверса", qty: "5 000 шт", status: "В обработке", statusColor: "bg-[#FEF3C7] text-[#D97706]", date: "14.05.2026" },
  { id: "ЗП-00140", client: "ТОО «Металл Пром»", product: "Фурнитура Z-серии", qty: "200 компл", status: "Выполнен", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "12.05.2026" },
  { id: "ЗП-00139", client: "ООО «КазСнаб»", product: "Крепёж оцинкованный", qty: "3 200 шт", status: "Выполнен", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "10.05.2026" },
  { id: "ЗП-00138", client: "ТОО «Пром Сталь»", product: "Профиль 100 мм", qty: "1 500 м", status: "Отправлен", statusColor: "bg-[#FEF3C7] text-[#D97706]", date: "09.05.2026" },
  { id: "ЗП-00137", client: "ИП Ким А.А.", product: "Саморезы 0500", qty: "450 шт", status: "Создан", statusColor: "bg-[#FEE2E2] text-[#DC2626]", date: "15.05.2026" },
  { id: "ЗП-00136", client: "ТОО «Юг-Снаб»", product: "Смазка 0800", qty: "800 м", status: "В обработке", statusColor: "bg-[#FEF3C7] text-[#D97706]", date: "13.05.2026" },
  { id: "ЗП-00135", client: "ООО «СтройДом»", product: "Фурнитура A-серии", qty: "150 компл", status: "Выполнен", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "08.05.2026" },
];

export const returnRequests: ReturnRequest[] = [
  { id: "ВЗ-00058", client: "ТОО «Альфа Сталь»", saleDoc: "РТУ-000238", reason: "Брак продукции — сколы на ниппелях", amount: 180000, status: "На рассмотрении", statusColor: "bg-[#FEF3C7] text-[#D97706]", date: "15.05.2026" },
  { id: "ВЗ-00057", client: "ООО «ТехноПласт»", saleDoc: "РТУ-000231", reason: "Несоответствие заказанной марки стали", amount: 95000, status: "Одобрен", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "14.05.2026" },
  { id: "ВЗ-00056", client: "ИП Султанов Е.Б.", saleDoc: "РТУ-000225", reason: "Повреждение упаковки при транспортировке", amount: 124000, status: "Одобрен", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "12.05.2026" },
  { id: "ВЗ-00055", client: "ТОО «Металл Пром»", saleDoc: "РТУ-000219", reason: "Неполная комплектация заказа", amount: 320000, status: "На рассмотрении", statusColor: "bg-[#FEF3C7] text-[#D97706]", date: "10.05.2026" },
  { id: "ВЗ-00054", client: "ООО «КазСнаб»", saleDoc: "РТУ-000208", reason: "Клиент отказался — передумал по объёму", amount: 245000, status: "Отклонён", statusColor: "bg-[#FEE2E2] text-[#DC2626]", date: "08.05.2026" },
  { id: "ВЗ-00053", client: "ТОО «Пром Сталь»", saleDoc: "РТУ-000201", reason: "Задержка доставки более 14 дней", amount: 560000, status: "На рассмотрении", statusColor: "bg-[#FEF3C7] text-[#D97706]", date: "07.05.2026" },
  { id: "ВЗ-00052", client: "ООО «СтройДом»", saleDoc: "РТУ-000195", reason: "Не тот цвет профиля (Ral 7024 вместо 9003)", amount: 178000, status: "Одобрен", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "05.05.2026" },
  { id: "ВЗ-00051", client: "ТОО «ЭлектроМир»", saleDoc: "РТУ-000187", reason: "Излишнее количество — ошибка менеджера", amount: 89000, status: "На рассмотрении", statusColor: "bg-[#FEF3C7] text-[#D97706]", date: "03.05.2026" },
  { id: "ВЗ-00050", client: "ИП Ким А.А.", saleDoc: "РТУ-000182", reason: "Брак покрытия саморезов — ржавчина", amount: 67000, status: "Одобрен", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "01.05.2026" },
];

export const customerReturns: CustomerReturnItem[] = [
  { id: "ВП-00034", client: "ТОО «Восток Трейд»", returnDoc: "ВН-000112", product: "Смазка 0600", qty: "200 м", amount: 86000, status: "Принят", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "14.05.2026" },
  { id: "ВП-00033", client: "ООО «СтройКомплект»", returnDoc: "ВН-000109", product: "Метиз, гриверса", qty: "800 шт", amount: 124000, status: "В обработке", statusColor: "bg-[#FEF3C7] text-[#D97706]", date: "13.05.2026" },
  { id: "ВП-00032", client: "ТОО «Альфа Сталь»", returnDoc: "ВН-000105", product: "Ниппель 1/2\"", qty: "50 шт", amount: 32000, status: "Завершён", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "10.05.2026" },
  { id: "ВП-00031", client: "ООО «ТехноПласт»", returnDoc: "ВН-000098", product: "Саморезы 0700", qty: "120 шт", amount: 19500, status: "Завершён", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "08.05.2026" },
  { id: "ВП-00030", client: "ИП Султанов Е.Б.", returnDoc: "ВН-000094", product: "Профиль 50 мм", qty: "150 м", amount: 61500, status: "Принят", statusColor: "bg-[#D4EDDA] text-[#2D6A4F]", date: "05.05.2026" },
  { id: "ВП-00029", client: "ТОО «Металл Пром»", returnDoc: "ВН-000087", product: "Фурнитура Z-серии", qty: "40 компл", amount: 112000, status: "В обработке", statusColor: "bg-[#FEF3C7] text-[#D97706]", date: "02.05.2026" },
];

export function formatMoney(value: number): string {
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 0,
  }).format(value);
}

export const kanbanStages: KanbanStage[] = [
  {
    key: "new-request",
    label: "Новый запрос",
    color: "bg-[#FEF3C7] text-[#B45309]",
    icon: "ri-lightbulb-line",
    cards: [
      { id: "СД-00095", client: "ООО «ТехноПласт»", product: "Саморезы 0700", amount: 340000, stage: "new-request", daysActive: 3, manager: "Иванов И.И.", nextAction: "Выставить счёт" },
      { id: "СД-00100", client: "ООО «СтройДом»", product: "Фурнитура A-серии", amount: 870000, stage: "new-request", daysActive: 4, manager: "Иванов И.И.", nextAction: "Подготовить презентацию" },
      { id: "СД-00103", client: "ИП Нурланов А.С.", product: "Профиль 75 мм", amount: 380000, stage: "new-request", daysActive: 1, manager: "Иванов И.И.", nextAction: "Выехать на объект" },
      { id: "СД-00105", client: "ООО «ТеплоДом»", product: "Смазка 0600", amount: 198000, stage: "new-request", daysActive: 2, manager: "Иванов И.И.", nextAction: "Отправить образцы" },
    ],
  },
  {
    key: "price-negotiation",
    label: "Согласование цены и условий",
    color: "bg-[#FDE68A] text-[#92400E]",
    icon: "ri-scales-line",
    cards: [
      { id: "СД-00088", client: "ИП Султанов Е.Б.", product: "Профиль 50 мм", amount: 960000, stage: "price-negotiation", daysActive: 7, manager: "Иванов И.И.", nextAction: "Позвонить — уточнить статус" },
      { id: "СД-00090", client: "ТОО «Металл Пром»", product: "Фурнитура Z-серии", amount: 1450000, stage: "price-negotiation", daysActive: 9, manager: "Иванов И.И.", nextAction: "Позвонить — напомнить о КП" },
      { id: "СД-00106", client: "ТОО «СнабКом»", product: "Саморезы 0700", amount: 850000, stage: "price-negotiation", daysActive: 5, manager: "Иванов И.И.", nextAction: "Подготовить спецпредложение" },
    ],
  },
  {
    key: "product-selection",
    label: "Подбор товара и объемов",
    color: "bg-[#FED7AA] text-[#9A3412]",
    icon: "ri-shopping-bag-3-line",
    cards: [
      { id: "СД-00099", client: "ТОО «Юг-Снаб»", product: "Смазка 0800", amount: 520000, stage: "product-selection", daysActive: 11, manager: "Иванов И.И.", nextAction: "Позвонить — срочно" },
      { id: "СД-00104", client: "ТОО «Азия Строй»", product: "Крепёж нерж.", amount: 670000, stage: "product-selection", daysActive: 10, manager: "Иванов И.И.", nextAction: "Уточнить статус тендера" },
    ],
  },
  {
    key: "stock-check",
    label: "Проверка наличия / Запрос",
    color: "bg-[#FEF9C3] text-[#854D0E]",
    icon: "ri-questionnaire-line",
    cards: [
      { id: "СД-00091", client: "ТОО «Восток Трейд»", product: "Смазка 0600", amount: 1800000, stage: "stock-check", daysActive: 12, manager: "Иванов И.И.", nextAction: "Согласовать скидку с РОП" },
      { id: "СД-00096", client: "ООО «КазСнаб»", product: "Крепёж оцинкованный", amount: 780000, stage: "stock-check", daysActive: 6, manager: "Иванов И.И.", nextAction: "Согласовать объём поставки" },
    ],
  },
  {
    key: "invoice-sent",
    label: "Счет отправлен — ожидание оплаты",
    color: "bg-[#FFEDD5] text-[#C2410C]",
    icon: "ri-bill-line",
    cards: [
      { id: "СД-00094", client: "ООО «СтройКомплект»", product: "Метиз, гриверса", amount: 2500000, stage: "invoice-sent", daysActive: 18, manager: "Иванов И.И.", nextAction: "Отправить финальное КП" },
      { id: "СД-00101", client: "ТОО «ЭлектроМир»", product: "Метиз, гровер", amount: 430000, stage: "invoice-sent", daysActive: 8, manager: "Иванов И.И.", nextAction: "Согласовать цену" },
      { id: "СД-00102", client: "ООО «ГидроСталь»", product: "Ниппель 3/4\"", amount: 1150000, stage: "invoice-sent", daysActive: 15, manager: "Иванов И.И.", nextAction: "Отправить договор" },
    ],
  },
  {
    key: "supplier-order",
    label: "Заказ поставщику",
    color: "bg-[#D1FAE5] text-[#065F46]",
    icon: "ri-shopping-cart-2-line",
    cards: [
      { id: "СД-00097", client: "ТОО «Пром Сталь»", product: "Профиль 100 мм", amount: 2100000, stage: "supplier-order", daysActive: 21, manager: "Иванов И.И.", nextAction: "Выставить счёт" },
    ],
  },
  {
    key: "shipped",
    label: "Отгружен",
    color: "bg-[#D4EDDA] text-[#2D6A4F]",
    icon: "ri-truck-line",
    cards: [
      { id: "СД-00107", client: "ООО «МегаСтрой»", product: "Фурнитура Z-серии", amount: 3200000, stage: "shipped", daysActive: 24, manager: "Иванов И.И.", nextAction: "Согласовать финальные правки" },
    ],
  },
  {
    key: "delivery",
    label: "Доставка клиенту",
    color: "bg-[#A7F3D0] text-[#064E3B]",
    icon: "ri-map-pin-2-line",
    cards: [
      { id: "СД-00108", client: "ТОО «АкваТех»", product: "Фитинги латунные", amount: 635000, stage: "delivery", daysActive: 32, manager: "Иванов И.И.", nextAction: "Подписать акт сдачи-приёмки" },
    ],
  },
  {
    key: "closing-docs",
    label: "Закрывающие документы",
    color: "bg-[#FEE2E2] text-[#991B1B]",
    icon: "ri-file-copy-2-line",
    cards: [
      { id: "СД-00109", client: "ООО «Индустрия Сталь»", product: "Профиль 100 мм", amount: 1750000, stage: "closing-docs", daysActive: 45, manager: "Иванов И.И.", nextAction: "—" },
    ],
  },
  {
    key: "closed-won",
    label: "Успешно закрыта",
    color: "bg-[#D1FAE5] text-[#065F46]",
    icon: "ri-check-double-line",
    cards: [],
  },
];

export const clientKanbanStages: ClientKanbanStage[] = [
  {
    key: "active",
    label: "Активные",
    color: "bg-[#D4EDDA] text-[#2D6A4F]",
    icon: "ri-user-star-line",
    cards: [
      { name: "ТОО «Восток Трейд»", segment: "Крупный опт", manager: "Иванов И.И.", lastPurchase: "15.05.2026", daysSincePurchase: 2, totalRevenue: 4820000, ordersCount: 12, lastSaleDoc: "РТУ-000246 от 15.05.2026", phone: "+7 (727) 355-31-48", status: "active" },
      { name: "ООО «СтройКомплект»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "14.05.2026", daysSincePurchase: 3, totalRevenue: 3150000, ordersCount: 9, lastSaleDoc: "РТУ-000247 от 14.05.2026", phone: "+7 (727) 292-15-22", status: "active" },
      { name: "ТОО «Альфа Сталь»", segment: "Крупный опт", manager: "Иванов И.И.", lastPurchase: "12.05.2026", daysSincePurchase: 5, totalRevenue: 2840000, ordersCount: 7, lastSaleDoc: "РТУ-000249 от 12.05.2026", phone: "+7 (727) 340-88-10", status: "active" },
      { name: "ООО «ТехноПласт»", segment: "Мелкий опт", manager: "Иванов И.И.", lastPurchase: "11.05.2026", daysSincePurchase: 6, totalRevenue: 1205000, ordersCount: 5, lastSaleDoc: "РТУ-000255 от 11.05.2026", phone: "+7 (727) 255-67-34", status: "active" },
      { name: "ТОО «Металл Пром»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "15.05.2026", daysSincePurchase: 2, totalRevenue: 5680000, ordersCount: 15, lastSaleDoc: "РТУ-000258 от 15.05.2026", phone: "+7 (727) 311-42-90", status: "active" },
      { name: "ООО «КазСнаб»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "15.05.2026", daysSincePurchase: 2, totalRevenue: 1980000, ordersCount: 6, lastSaleDoc: "РТУ-000264 от 15.05.2026", phone: "+7 (727) 278-33-15", status: "active" },
      { name: "ТОО «ЭлектроМир»", segment: "Крупный опт", manager: "Иванов И.И.", lastPurchase: "10.05.2026", daysSincePurchase: 7, totalRevenue: 3720000, ordersCount: 11, lastSaleDoc: "РТУ-000241 от 10.05.2026", phone: "+7 (727) 369-21-44", status: "active" },
      { name: "ООО «ГидроСталь»", segment: "Крупный опт", manager: "Иванов И.И.", lastPurchase: "08.05.2026", daysSincePurchase: 9, totalRevenue: 4450000, ordersCount: 14, lastSaleDoc: "РТУ-000239 от 08.05.2026", phone: "+7 (727) 244-56-78", status: "active" },
      { name: "ИП Нурланов А.С.", segment: "Мелкий опт", manager: "Иванов И.И.", lastPurchase: "13.05.2026", daysSincePurchase: 4, totalRevenue: 680000, ordersCount: 3, lastSaleDoc: "РТУ-000251 от 13.05.2026", phone: "+7 (701) 555-12-34", status: "active" },
      { name: "ТОО «Азия Строй»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "09.05.2026", daysSincePurchase: 8, totalRevenue: 2560000, ordersCount: 8, lastSaleDoc: "РТУ-000242 от 09.05.2026", phone: "+7 (727) 388-90-21", status: "active" },
      { name: "ООО «ТеплоДом»", segment: "Мелкий опт", manager: "Иванов И.И.", lastPurchase: "10.05.2026", daysSincePurchase: 7, totalRevenue: 890000, ordersCount: 4, lastSaleDoc: "РТУ-000244 от 10.05.2026", phone: "+7 (727) 215-43-87", status: "active" },
      { name: "ТОО «СнабКом»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "07.05.2026", daysSincePurchase: 10, totalRevenue: 1940000, ordersCount: 7, lastSaleDoc: "РТУ-000237 от 07.05.2026", phone: "+7 (727) 322-11-56", status: "active" },
    ],
  },
  {
    key: "inactive",
    label: "Неактивные",
    color: "bg-[#FEF3C7] text-[#D97706]",
    icon: "ri-user-unfollow-line",
    cards: [
      { name: "ТОО «Пром Сталь»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "12.01.2026", daysSincePurchase: 185, totalRevenue: 3520000, ordersCount: 18, lastSaleDoc: "РТУ-000118 от 12.01.2026", phone: "+7 (727) 299-67-12", status: "dormant" },
      { name: "ООО «Металл»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "18.02.2026", daysSincePurchase: 148, totalRevenue: 2860000, ordersCount: 14, lastSaleDoc: "РТУ-000145 от 18.02.2026", phone: "+7 (727) 244-33-89", status: "dormant" },
      { name: "ИП Ким А.А.", segment: "Мелкий опт", manager: "Иванов И.И.", lastPurchase: "05.12.2025", daysSincePurchase: 223, totalRevenue: 1240000, ordersCount: 8, lastSaleDoc: "РТУ-000091 от 05.12.2025", phone: "+7 (701) 777-45-21", status: "dormant" },
      { name: "ТОО «Юг-Снаб»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "15.03.2026", daysSincePurchase: 123, totalRevenue: 2180000, ordersCount: 11, lastSaleDoc: "РТУ-000172 от 15.03.2026", phone: "+7 (727) 333-88-45", status: "dormant" },
      { name: "ИП Садыков Р.Т.", segment: "Мелкий опт", manager: "Иванов И.И.", lastPurchase: "10.05.2026", daysSincePurchase: 7, totalRevenue: 340000, ordersCount: 2, lastSaleDoc: "РТУ-000243 от 10.05.2026", phone: "+7 (702) 333-67-89", status: "noContact" },
    ],
  },
  {
    key: "noSales",
    label: "Без продаж",
    color: "bg-[#E8E0D5] text-[#6B5B4D]",
    icon: "ri-forbid-line",
    cards: [
      { name: "ТОО «АкваСтрой»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "—", daysSincePurchase: 999, totalRevenue: 0, ordersCount: 0, lastSaleDoc: "—", phone: "+7 (727) 311-45-67", status: "noSales" },
      { name: "ООО «ГрандТекс»", segment: "Крупный опт", manager: "Иванов И.И.", lastPurchase: "—", daysSincePurchase: 999, totalRevenue: 0, ordersCount: 0, lastSaleDoc: "—", phone: "+7 (701) 888-22-33", status: "noSales" },
      { name: "ИП Асанова Л.К.", segment: "Мелкий опт", manager: "Иванов И.И.", lastPurchase: "—", daysSincePurchase: 999, totalRevenue: 0, ordersCount: 0, lastSaleDoc: "—", phone: "+7 (702) 444-11-55", status: "noSales" },
      { name: "ТОО «ЕвроТрейд KZ»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "—", daysSincePurchase: 999, totalRevenue: 0, ordersCount: 0, lastSaleDoc: "—", phone: "+7 (727) 355-78-90", status: "noSales" },
    ],
  },
  {
    key: "lost",
    label: "Потерянные",
    color: "bg-[#FEE2E2] text-[#DC2626]",
    icon: "ri-close-circle-line",
    cards: [
      { name: "ООО «СтройДом»", segment: "Крупный опт", manager: "Иванов И.И.", lastPurchase: "20.11.2025", daysSincePurchase: 238, totalRevenue: 4670000, ordersCount: 22, lastSaleDoc: "РТУ-000074 от 20.11.2025", phone: "+7 (727) 266-54-33", status: "lost" },
      { name: "ТОО «КазПромСнаб»", segment: "Крупный опт", manager: "Иванов И.И.", lastPurchase: "03.09.2025", daysSincePurchase: 316, totalRevenue: 5890000, ordersCount: 26, lastSaleDoc: "РТУ-000038 от 03.09.2025", phone: "+7 (727) 299-11-67", status: "lost" },
      { name: "ООО «Индустрия Стиль»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "22.07.2025", daysSincePurchase: 359, totalRevenue: 1750000, ordersCount: 9, lastSaleDoc: "РТУ-000021 от 22.07.2025", phone: "+7 (727) 211-88-90", status: "lost" },
      { name: "ТОО «АкваТех»", segment: "Средний опт", manager: "Иванов И.И.", lastPurchase: "15.05.2025", daysSincePurchase: 427, totalRevenue: 2920000, ordersCount: 13, lastSaleDoc: "РТУ-000005 от 15.05.2025", phone: "+7 (727) 355-19-44", status: "lost" },
      { name: "ООО «СпецМонтаж»", segment: "Крупный опт", manager: "Иванов И.И.", lastPurchase: "28.03.2025", daysSincePurchase: 475, totalRevenue: 7430000, ordersCount: 31, lastSaleDoc: "РТУ-000001 от 28.03.2025", phone: "+7 (727) 244-77-12", status: "lost" },
    ],
  },
];